import { useState, useEffect } from 'react';
import logger from '../../utils/logger';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function useUsernameCheck() {
  const [username, setUsername] = useState('');
  const [currentUsername, setCurrentUsername] = useState('');
  const [checking, setChecking] = useState(false);
  const [available, setAvailable] = useState(null);

  useEffect(() => {
    const fetchCurrentUsername = async () => {
      try {
        const token = localStorage.getItem('auth_token');
        const response = await fetch(`${BACKEND_URL}/api/auth/me`, {
          headers: { 'Authorization': `Bearer ${token}` },
        });
        if (response.ok) {
          const data = await response.json();
          if (data.username) { setCurrentUsername(data.username); setUsername(data.username); }
        }
      } catch (err) { logger.error('Error fetching username:', err); }
    };
    fetchCurrentUsername();
  }, []);

  const checkAvailability = async (value) => {
    if (!value || value.length < 3) { setAvailable(null); return; }
    setChecking(true);
    try {
      const response = await fetch(`${BACKEND_URL}/api/users/username/check?username=${value}`);
      const data = await response.json();
      setAvailable(data.available);
    } catch (err) { logger.error('Error checking username:', err); }
    finally { setChecking(false); }
  };

  const handleUsernameChange = (e) => {
    const value = e.target.value.toLowerCase().trim();
    setUsername(value);
    setAvailable(null);
    clearTimeout(window.usernameCheckTimeout);
    window.usernameCheckTimeout = setTimeout(() => {
      if (value) checkAvailability(value);
    }, 500);
  };

  return { username, currentUsername, setCurrentUsername, checking, available, setAvailable, handleUsernameChange };
}
